import { gql, useQuery } from '@apollo/client';
import type { BookingFilters } from '__generated__/globalTypes';
import { getDateString } from '../../lib';
import type {
  getAvailableBookingTimeslots,
  getAvailableBookingTimeslotsVariables,
} from './__generated__/getAvailableBookingTimeslots';

export const GET_TIMESLOTS = gql`
  query getAvailableBookingTimeslots(
    $serviceId: ID!
    $emailAddress: String!
    $date: Date!
    $filters: BookingFilters!
  ) {
    availableBookingTimes(
      input: {
        serviceId: $serviceId
        emailAddress: $emailAddress
        date: $date
        filters: $filters
      }
    ) {
      date
      timeSlots {
        to
        from
      }
    }
  }
`;

export const useGetTimeslots = (
  serviceId: string,
  emailAddress: string,
  filters: BookingFilters,
  date?: Date,
) => {
  const { data, loading, error } = useQuery<
    getAvailableBookingTimeslots,
    getAvailableBookingTimeslotsVariables
  >(GET_TIMESLOTS, {
    variables: {
      serviceId,
      emailAddress,
      date: date ? getDateString(date) : undefined,
      filters,
    },
    errorPolicy: 'all',
    returnPartialData: false,
    skip: !date,
  });

  return { data, loading, error };
};
